module.exports = __webpack_public_path__ + "static/img/pc-06.891b106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x3/pc-06.jpg
// module id = 6IEW
// module chunks = 1